var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('Margins',[(_vm.text)?_c('p',{class:[
        'loader__text',
        'margins__double',
        { 'has-loading-dots': _vm.textLoadingIndicator },
      ]},[_c('span',[_vm._v(_vm._s(_vm.text))]),(!_vm.textLoadingIndicator)?_c('span',[_vm._v("...")]):_vm._e()]):_vm._e(),(!_vm.textLoadingIndicator)?_c('LoaderSVG',{class:['icon', 'loader__icon', { margins__double: !!_vm.text }]}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }